// extracted by mini-css-extract-plugin
export default {"prefix":"NewContactDialog_prefix__lreiQ","phoneCtrl":"NewContactDialog_phoneCtrl__dhtgC","divider":"NewContactDialog_divider__Rba2Y"};